  // window.addEventListener("scroll", function () {
  //     console.log("scroll",window.scrollY);
  //   });
  // const box = document.getElementById("box");
  //   console.log("offsetHeight:", box.offsetHeight);

//form popup
// let form = document.querySelector('.code_setting');
// document.querySelector('.consultation_appointment_btn')?.addEventListener('click', () => {
//   form?.classList.add('active');
//   document.querySelector('.form_overLay').style.display = 'block';
//   document.querySelector('body.overflow_popup').style.overflow = 'hidden';
// });
// document.querySelector('.popup_cancel_btn')?.addEventListener('click',()=>{
//   form?.classList.remove('active');
//   document.querySelector('.form_overLay').style.display = 'none';
//   document.querySelector('body.overflow_popup').style.overflow = 'auto';
// })


  document.addEventListener('DOMContentLoaded', function () {
    let form = document.querySelector('.code_setting');
    let overlay = document.querySelector('.form_overLay');
    let body = document.querySelector('body');
    let body_image = document.querySelector('.consultation_appointment_image_hide');
    let header_popup = document.querySelector('#shopify-section-header1')
    let cancel_btn = document.querySelector(".popup_cancel_btn");

    // Target all BOOK APPOINTMENT buttons
    document.querySelectorAll('.consultation_appointment_btn a').forEach(button => {
      button.addEventListener('click', () => {
        form?.classList.add('active');
        overlay.style.display = 'block';
        body.classList.add('overflow_popup');
        body.style.overflow = 'hidden';
        body_image.style.display = "none";
        header_popup.style.display = "none";
        cancel_btn.style.display = "block";
      });
    });

    // Handle popup cancel
    document.querySelector('.popup_cancel_btn')?.addEventListener('click', () => {
      form?.classList.remove('active');
      overlay.style.display = 'none';
      body.classList.remove('overflow_popup');
      body.style.overflow = 'auto';
      body_image.style.display = "block";
      header_popup.style.display = "block";
      cancel_btn.style.display = "none";
    });
  });





// const over_lay_btn = document.querySelector('.consultation_appointment_btn');
